<!-- Toast Container (Top Right) -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 2000;">

  <!-- Success Toast -->
  <div id="successToast" class="toast align-items-center text-white bg-success border-0" role="alert">
    <div class="d-flex">
      <div class="toast-body" id="successToastMessage">
        Success message
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>
  </div>

  <!-- Error Toast -->
  <div id="errorToast" class="toast align-items-center text-white bg-danger border-0" role="alert">
    <div class="d-flex">
      <div class="toast-body" id="errorToastMessage">
        Error message
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>
  </div>

</div>

@if(!isLoginPage){
<nav class="py-3 px-5 bg-primary position-fixed top-0 w-100 shadow "
  style="z-index: 500; background: linear-gradient(45deg, #1A2042, #173580);">
  <div class="d-flex justify-content-between align-items-center flex-column flex-sm-row">
    <div>
      <div class="fs-3 fw-bold text-white logo d-flex align-items-center">
        <img src="Logo-ChalkBasket-logo.png" alt="Chalk Basket Logo" class="logo-img me-1">
        &nbsp;Chalk&nbsp; <span class="text-white">Basket</span>
      </div>
    </div>
    <div class="d-flex mt-2 mt-lg-0 gap-5 fw-bold ">
      <div class="link-div">
        <a routerLink="/" class=" text-decoration-none" (click)="scrollToTop()">Home</a>
      </div>
      <div class="link-div">
        <a routerLink="/about" class=" text-decoration-none" (click)="scrollToTop()">About<span
            class="d-none d-sm-inline"> Us</span></a>
      </div>
      <div class="link-div">
        <a routerLink="/contact" class=" text-decoration-none" (click)="scrollToTop()">Contact <span
            class="d-none d-sm-inline"> Us</span></a>
      </div>
      <div class="link-div" *ngIf="isAdmin">
        <a routerLink="/details" class=" text-decoration-none" (click)="scrollToTop()">Details</a>
      </div>
      <div class="link-div" *ngIf="isAdmin">
        <a routerLink="/workshop" class=" text-decoration-none" (click)="scrollToTop()">Workshop</a>
      </div>
      <div class="link-div" *ngIf="isAdmin">
        <a class=" text-decoration-none" (click)="logout()">Logout</a>
      </div>
    </div>
  </div>
</nav>
}

<router-outlet></router-outlet>

@if(!isLoginPage){
<footer>
  <div class="container-fluid p-3 p-lg-5 pb-lg-2"
    style="background: linear-gradient(45deg, #1A2042, #0c225a); color:#fff;">
    <!-- Main links section using Bootstrap grid -->
    <div class="d-flex flex-column flex-sm-row justify-content-evenly px-2 ">
      <!-- Column 1: Main Pages -->
      <div class="">
        <div class="footer-column">
          <h4>Main Pages</h4>
          <ul>
            <li class="link-div" (click)="scrollToTop()"><a routerLink="/">Home</a></li>
            <li class="link-div" (click)="scrollToTop()"><a routerLink="/about">About Us</a></li>
            <li class="link-div" (click)="scrollToTop()"><a routerLink="/contact">Contact Us</a></li>
          </ul>
        </div>
      </div>

      <!-- Column 2: Legal & Accessibility -->
      <div class="">
        <div class="footer-column">
          <h4>Legal & Accessibility</h4>
          <ul>

            <li><a routerLink="/disclaimer" (click)="scrollToTop()">Disclaimer</a></li>
            <li><a routerLink="/privacy-policy" (click)="scrollToTop()">Privacy Policy</a></li>

            <li><a routerLink="/terms-and-conditions" (click)="scrollToTop()">Terms conditions</a></li>
            <li><a routerLink="/cancellation-policy" (click)="scrollToTop()">Cancellation policy</a></li>



          </ul>
        </div>
      </div>

      <!-- Column 3: Connect Links -->
      <!-- <div class="">
        <div class="footer-column">
          <h4>Connect</h4>
          <ul>
            <li><a href="#hi">Facebook</a></li>
            <li><a href="#">Twitter</a></li>
            <li><a href="#">LinkedIn</a></li>
            <li><a href="#">Instagram</a></li>
          </ul>
        </div>
      </div> -->
    </div>

    <!-- Footer Description / About Company -->
    <div class="footer-description text-center">
      <p>
        &copy; 2025 Chalk Basket
        All rights reserved.
      </p>
    </div>
  </div>
</footer>
}